import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "18",
  viewBox: "0 0 16 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.323 5.95974C12.5818 5.18326 11.8431 4.44454 11.0666 4.70337L1.16187 8.00494C0.461394 8.23843 0.251525 9.12745 0.773626 9.64955L3.06656 11.9425L7.30282 9.7235L5.08383 13.9598L7.37678 16.2527C7.89888 16.7748 8.7879 16.5649 9.02139 15.8645L12.323 5.95974Z",
  fill: "currentcolor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "1.5",
  cy: "15.5",
  r: "1.5",
  fill: "currentcolor"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }